<template>
  <PVDatePicker
    v-bind="$attrs"
    v-model="forwardValue"
    :dateFormat="dateFormat"
    showIcon
    iconDisplay="input"
    :panelClass="['date-picker-overlay', insideBootstrapOverlay ? 'inside-bs' : null]"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { modelDateFormat } from '@/utils/misc'
import PVDatePicker from 'primevue/datepicker'

export default {
  name: 'DatePicker',
  inheritAttrs: false,
  components: {
    PVDatePicker
  },
  props: {
    modelValue: String,
    insideBootstrapOverlay: Boolean
  },
  emits: ['update:modelValue'],
  computed: {
    ...mapGetters({
      dateFormat: 'formatPreferences/pvDateFormat'
    }),
    forwardValue: {
			get () {
				return this.modelValue ? moment(this.modelValue).toDate() : null
			},
			set (v) {
				this.$emit('update:modelValue', v ? moment(v).format(modelDateFormat) : null)
			}
    }
  }
}
</script>

<style scoped>
.p-datepicker {
  font-size: .9rem;
}

.p-datepicker :deep(.p-inputtext) {
  width: 150px;
  padding: 0.25rem 0.5rem;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 4px;
}
</style>

<style>
.date-picker-overlay {
  &.inside-bs {
    /* above bootstrap modal containing it */
    z-index: 1156 !important;
  }
}
</style>
